"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
var tslib_1 = require("tslib");
var apisauce_1 = tslib_1.__importDefault(require("apisauce"));
var config_1 = tslib_1.__importDefault(require("./config"));
var utils_1 = require("./utils");
var BaseService = /** @class */ (function () {
    function BaseService(accessToken, baseURL, timeout, extraHeaders) {
        if (timeout === void 0) { timeout = config_1.default.TIMEOUT; }
        if (accessToken) {
            this.api = apisauce_1.default.create({
                baseURL: baseURL,
                headers: tslib_1.__assign({ Authorization: "Bearer ".concat(accessToken), 'Content-Type': 'application/json' }, extraHeaders),
                timeout: timeout,
            });
        }
        else {
            this.api = apisauce_1.default.create({
                baseURL: baseURL,
                headers: tslib_1.__assign({ 'Content-Type': 'application/json' }, extraHeaders),
                timeout: timeout,
            });
        }
    }
    Object.defineProperty(BaseService.prototype, "_axiosInstance", {
        /**
         * Backend engine instance -- used for testing
         */
        get: function () {
            return this.api.axiosInstance;
        },
        enumerable: false,
        configurable: true
    });
    BaseService.prototype.handleResponse = function (model, url, res) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (res.ok) {
                    return [2 /*return*/, Promise.resolve(res.data)];
                }
                else {
                    throw new utils_1.ApiRequestError(res.status || 0, res.problem, url, res.data);
                }
                return [2 /*return*/];
            });
        });
    };
    return BaseService;
}());
exports.BaseService = BaseService;
